import { render, staticRenderFns } from "./PriceField.vue?vue&type=template&id=be5c08b4&"
import script from "./PriceField.vue?vue&type=script&lang=js&"
export * from "./PriceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be5c08b4')) {
      api.createRecord('be5c08b4', component.options)
    } else {
      api.reload('be5c08b4', component.options)
    }
    module.hot.accept("./PriceField.vue?vue&type=template&id=be5c08b4&", function () {
      api.rerender('be5c08b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/fields/PriceField.vue"
export default component.exports